document.addEventListener("DOMContentLoaded", function() {
  attachAddToCartEventListeners();
  attachMiniCartEventListeners();
  attachCartIconEventListeners();
});

function attachAddToCartEventListeners() {
  document.querySelectorAll(".add-to-cart-form").forEach(form => {
    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);

    newForm.addEventListener("submit", function(event) {
      event.preventDefault();
      const productId = this.getAttribute("data-product-id");
      const quantityInput = this.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ quantity: quantity, id: productId }),
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => response.json())
      .then(data => {
        alert("Tuote lisätty ostoskoriin!");
        updateCartData(); // Päivitetään mini-cart
      })
      .catch(error => console.error('Virhe lisättäessä ostoskoriin:', error));
    });
  });
}

// Päivitetään mini-cart ilman sivun lataamista
function updateCartData() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateMiniCart(cart);
      updateCartCount(cart);
    })
    .catch(error => console.error('Virhe päivittäessä ostoskoria:', error));
}

function updateMiniCart(cart) {
  const miniCartItems = document.getElementById('mini-cart-items');
  miniCartItems.innerHTML = cart.items.map(item => `
    <div class="mini-cart-item" id="MiniCartItem-${item.id}">
      <img src="${item.image}" alt="${item.title}">
      <div>
        <p>${item.title}</p>
        <div class="edit-container">
          <div class="quantity-popover-container quantity-padding">
            <quantity-input class="quantity cart-quantity quantity-nappi">
              <button class="quantity__button plus-miinus" name="minus" type="button">-</button>
              <input class="quantity__input mini-cart-quantity"
                     data-quantity-variant-id="${item.id}"
                     type="number"
                     name="updates[]"
                     value="${item.quantity}"
                     min="0">
              <button class="quantity__button plus-miinus" name="plus" type="button">+</button>
            </quantity-input>
          </div>
          <cart-remove-button
            id="Remove-${item.id}"
            data-index="${item.id}"
            data-remove-url="/cart/change.js"
          >
            <a
              href="#"
              class="button button--tertiary mini-cart-remove"
              aria-label="Remove ${item.title}"
              data-id="${item.id}"
            >
              <span class="svg-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 6H5H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </a>
          </cart-remove-button>
        </div>
      </div>
    </div>
  `).join('');

  attachMiniCartEventListeners(); // Lisää kuuntelijat uudelleen
  updateCartCount(cart);
}

function attachMiniCartEventListeners() {
  document.querySelectorAll('.mini-cart-quantity').forEach(input => {
    input.addEventListener('change', function() {
      const itemId = this.getAttribute('data-quantity-variant-id');
      const newQuantity = parseInt(this.value, 10); // Muunna numero
      if (!isNaN(newQuantity) && newQuantity >= 0) {
        updateCartItemQuantity(itemId, newQuantity);
      } else {
        console.error('Invalid quantity:', this.value);
      }
    });
  });

  document.querySelectorAll('.mini-cart-remove').forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const itemId = this.getAttribute('data-id');
      removeCartItem(itemId);
    });
  });
}

function updateCartItemQuantity(itemId, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: itemId, quantity: quantity })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 'success') {
      document.querySelector(`#MiniCartItem-${itemId} .mini-cart-quantity`).value = quantity;
      updateMiniCart(data); // Päivitä minikori
      updateCartCount(data); // Päivitä headerin ostoskorin lukumäärä
    } else {
      console.error('Failed to update item quantity:', data.message);
    }
  })
  .catch(error => {
    console.error('Error updating item quantity:', error);
  });
}

function removeCartItem(itemId) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: itemId, quantity: 0 })
  })
  .then(response => response.json())
  .then(data => {
    updateMiniCart(data); // Päivitä minikori
  })
  .catch(error => {
    console.error('Error removing item from cart:', error);
  });
}

function updateCartCount(cart) {
  const cartBubble = document.querySelector('.cart-count-bubble span');
  if (cartBubble) {
    cartBubble.textContent = cart.item_count; // Päivitä tuotteiden lukumäärä
  } else {
    console.error('Cart count bubble element not found.');
  }
}

function attachCartIconEventListeners() {
  const miniCart = document.getElementById('mini-cart');
  const cartIcon = document.getElementById('cart-icon-bubble');
  const closeMiniCart = document.querySelector('.close-mini-cart');

  cartIcon.addEventListener('click', function(event) {
    event.preventDefault();
    miniCart.style.display = 'block';
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        updateMiniCart(data);
      });
  });

  closeMiniCart.addEventListener('click', function() {
    miniCart.style.display = 'none';
  });

  window.addEventListener('click', function(event) {
    if (event.target == miniCart) {
      miniCart.style.display = 'none';
    }
  });
}